import { render } from "./StrategiesTable.vue?vue&type=template&id=7048b9d0&scoped=true"
import script from "./StrategiesTable.vue?vue&type=script&lang=js"
export * from "./StrategiesTable.vue?vue&type=script&lang=js"

import "./StrategiesTable.vue?vue&type=style&index=0&id=7048b9d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7048b9d0"

export default script